/**
 * DreamPay Private API
 * Private API v2 - Current version with JWT authentication, role-based access control, and enhanced security features.
 *
 * The version of the OpenAPI document: v2
 * Contact: suporte@dreampay.com.br
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface ReconciliationTransactionDtoV2 {
  id?: number;
  date?: string;
  tid?: string;
  authorizationCode?: string;
  proofSale?: string;
  totalValueBrl?: number;
  installments?: number;
  cardNumber?: string;
  cardType?: string;
  cardProcessingComission?: number | null;
  cardProcessingCostBrl?: number | null;
  antecipationComission?: number | null;
  antecipationCostBrl?: number | null;
  totalFeesRate?: number | null;
  totalFeesValue?: number | null;
  providerNetValue?: number | null;
  paid?: boolean;
  canceled?: boolean;
  providerReconciled?: boolean;
  establismentName?: string | null;
  customerName?: string | null;
  estimatedMarginPercentage?: number | null;
}
